/* Filtrous - clearance BOGO offer placement (2026-08-04).

   The app (assets/filtrous-v3.js) renders ONE line under the buy row:
   "Buy One, Get One Free - just add 2 to cart. No code needed."
   It sat after the decision point, sharing weight and colour with the Net-30
   note beneath it, so it read as fine print and went unread.

   This splits that single line into two placements:
     1. "Buy One, Get One Free" - thin teal, ABOVE "Part number" (top of buy
        box), so the offer is seen before the price and quantity are
        considered.
     2. "Applies only when 2 items are in your cart." - teal, directly UNDER
        the quantity counter / Add-to-cart row, where the condition is
        actionable.

   Gate: acts only where the app already emitted `.pdp-bogo` - i.e. exactly the
   20 SKUs in BOGO_SKUS. No SKU list is duplicated here, so the two can never
   drift apart.

   Revert: remove the Clearance BOGO offer section from templates/product.json.
   The original .pdp-bogo line returns on its own.
*/
(function () {
  if (window.__fbogoInit) return;
  window.__fbogoInit = true;

  var DTEAL = '#0d7d68'; /* --dteal */

  var CFG = window.FBOGO_CONFIG || {};
  var T_BADGE = CFG.badge || 'Buy One, Get One Free';
  var T_COND = CFG.condition || 'Applies only when 2 items are in your cart.';

  function badge() {
    var d = document.createElement('div');
    d.className = 'pdp-bogo-badge';
    d.setAttribute(
      'style',
      'margin:0 0 6px;font-size:13px;font-weight:300;line-height:1.3;color:' +
        DTEAL + ';'
    );
    d.textContent = T_BADGE;
    return d;
  }

  function condition() {
    var d = document.createElement('div');
    d.className = 'pdp-bogo-cond';
    d.setAttribute(
      'style',
      'margin:8px 0 0;font-size:13px;font-weight:400;line-height:1.4;color:' +
        DTEAL + ';'
    );
    d.textContent = T_COND;
    return d;
  }

  function apply() {
    var old = document.querySelector('#fv3-app .pdp-bogo');
    if (!old) return;

    var buy = old.parentNode;
    if (!buy) return;

    /* already placed on this render - just drop the legacy line */
    if (buy.querySelector('.pdp-bogo-badge')) {
      old.parentNode.removeChild(old);
      return;
    }

    /* 1. thin teal badge above "Part number" (first child of the buy box) */
    var label = buy.querySelector('.partlabel') || buy.firstChild;
    if (label) buy.insertBefore(badge(), label);

    /* 2. teal condition line under the qty counter / Add-to-cart row */
    var row = buy.querySelector('.fv3-buyrow');
    if (row && row.nextSibling) buy.insertBefore(condition(), row.nextSibling);
    else if (row) buy.appendChild(condition());
    else buy.insertBefore(condition(), old);

    old.parentNode.removeChild(old);
  }

  function boot() {
    apply();
    var mount = document.getElementById('fv3-app') || document.body;
    new MutationObserver(apply).observe(mount, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
